

export default {
    // module assets
    namespaced: true,
    state: {
        outpatientlist:0
       
     },

    getters: {

       
    },

    actions: {

    },

    mutations: {

       
    },
}
